import React from 'react';
import visioradLogo from '../assets/visioradai-logo.svg';
import varisymoLogo from '../assets/varisymo-logo.png';
import wellmumLogo from '../assets/thewellmum-logo.png';

const chipBase = 'flex items-center gap-3 px-6 py-3.5 bg-nf-bg3 border border-white/[0.06] rounded-xl transition-all duration-300';

export default function PartnersBanner({ navigate }) {
  return (
    <div className="bg-nf-bg2 border-t border-b border-white/[0.06] py-10 sm:py-[52px] px-4 sm:px-10 lg:px-20 relative z-[1]">
      <span className="block text-center text-[11px] font-semibold tracking-[0.12em] uppercase text-nf-t3 mb-9">
        Trusted partners &amp; ecosystem
      </span>
      <div className="flex items-center justify-center gap-6 sm:gap-10 flex-wrap">

        {/* VisioRAD.ai */}
        <a
          href="https://www.visioradai.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={`${chipBase} hover:border-[#3B82F6]/30 hover:-translate-y-0.5 no-underline`}>
          <div className="w-[38px] h-[38px] rounded-[9px] flex items-center justify-center shrink-0"
            style={{ background: 'rgba(59,130,246,0.10)' }}>
            <img
              src={visioradLogo}
              alt="VisioRad AI"
              className="w-[26px] h-[26px] object-contain"
            />
          </div>
          <div>
            <div className="font-heading text-[17px] font-extrabold tracking-tight whitespace-nowrap"
              style={{ color: '#3B82F6' }}>
              VisioRad<span className="font-normal opacity-60"> AI</span>
            </div>
            <div className="text-[11px] text-nf-t3 mt-0.5 whitespace-nowrap">AI Radiology Intelligence</div>
          </div>
        </a>

        {/* Varisymo */}
        <a
          href="https://varisymo.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={`${chipBase} hover:border-[#6366f1]/30 hover:-translate-y-0.5 no-underline`}>
          <div className="w-[38px] h-[38px] rounded-[9px] flex items-center justify-center shrink-0 overflow-hidden"
            style={{ background: 'rgba(99,102,241,0.10)' }}>
            <img
              src={varisymoLogo}
              alt="Varisymo"
              className="w-[28px] h-[28px] object-contain"
            />
          </div>
          <div>
            <div className="font-heading text-[17px] font-extrabold tracking-tight whitespace-nowrap"
              style={{ color: '#6366f1' }}>
              Varisymo
            </div>
            <div className="text-[11px] text-nf-t3 mt-0.5 whitespace-nowrap">Self-Hosted Cloud Apps</div>
          </div>
        </a>

        {/* The Well Mum */}
        <a
          href="https://www.thewellmum.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={`${chipBase} hover:border-[#c084a0]/30 hover:-translate-y-0.5 no-underline`}>
          <div className="w-[38px] h-[38px] rounded-[9px] flex items-center justify-center shrink-0 overflow-hidden"
            style={{ background: 'rgba(255,255,255,0.07)' }}>
            <img
              src={wellmumLogo}
              alt="The Well Mum"
              className="w-[30px] h-[30px] object-contain"
            />
          </div>
          <div>
            <div className="font-heading text-[17px] font-extrabold tracking-tight whitespace-nowrap"
              style={{ color: '#d4a0b5' }}>
              The Well Mum
            </div>
            <div className="text-[11px] text-nf-t3 mt-0.5 whitespace-nowrap">Wellness Coaching for Mums</div>
          </div>
        </a>

        {/* Become a partner */}
        <div
          className="flex items-center gap-3 px-6 py-3.5 bg-[rgba(109,40,217,0.04)] border border-dashed border-[rgba(109,40,217,0.3)] rounded-xl cursor-pointer transition-all duration-300 hover:border-[rgba(109,40,217,0.5)] hover:-translate-y-0.5"
          onClick={() => navigate('about')}>
          <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
            <rect width="38" height="38" rx="9" fill="rgba(109,40,217,0.12)" />
            <line x1="19" y1="11" x2="19" y2="27" stroke="#a78bfa" strokeWidth="1.8" strokeLinecap="round" />
            <line x1="11" y1="19" x2="27" y2="19" stroke="#a78bfa" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
          <div>
            <div className="font-heading text-[17px] font-extrabold tracking-tight whitespace-nowrap text-nf-acc">Become a partner</div>
            <div className="text-[11px] mt-0.5 whitespace-nowrap" style={{ color: 'rgba(196,181,253,0.45)' }}>Join the ecosystem</div>
          </div>
        </div>

      </div>
    </div>
  );
}
